/* eslint-disable no-unused-vars */
export enum PoolState {
  POOLSTATE_WAITING, // Waiting, /// 대기 (다음 상태: 모금)
  POOLSTATE_FUNDRAISING, // Fundraising, /// 모금 진행 (다음 상태: 운영 or 모금 잠김 or 모금 중지 or 모금 실패)
  POOLSTATE_FUNDRAISING_LOCKED, // FundraisingLocked, /// 모금 잠김 (다음 상태: 운영)
  POOLSTATE_FUNDRAISING_STOPPED, // FundraisingStopped, /// 모금 중지
  POOLSTATE_FUNDRAISING_FAILED, // FundraisingFailed, /// 모금 실패
  POOLSTATE_OPERATING, // Operating, /// 운영 (다음 상태: 운영 종료 or 운영 중지)
  POOLSTATE_OPERATING_CLOSED, // OperatingClosed, /// 운영 종료
  POOLSTATE_OPERATING_STOPPED, // OperatingStopped, /// 운영 중지
}

export const MULTIPLIE_PERCENT = 2;
export const REQUIRED_CONFIRMATIONS = 5;
export const MIN_CONFIRMATIONS = 2; // 최소 필요 confirmation (이 이상이면 즉시 완료)
export const MAX_CONFIRMATION_WAIT_TIME = 30000; // 최대 30초까지 추가 confirmation 대기
export enum STAKING_POOL_REWARD_STATE {
  WAINTING, // 0 대기
  ING, // 1 진행 중
  END_SUCCESS, // 2 성공(아마 안쓸듯) -> 유저가 리워드 하고 난 뒤 세팅은 진행 중이지만 유저화면은 성공으로 처리
  END_FAIL, // 3 실패(컨트랙트 배포 실패)
}

export enum STAKING_USER_STATE {
  STAKING, // 0 스테이킹
  UNSTAKING, // 1 언스테이킹
  WITHDRAW, // 2 회수 (스테이킹 - 언스테이킹 = 0일 때 성립)
  REWARD, //3 리워드 ※ 주의 db테이블이 분리되어 있다.
  WAIT_STAKE, // 4 스테이킹 대기 (컨트랙트에는 없는 타입, 티커와, 일 이자 세팅 업데이트)
  PENDING, // 5 펜딩(성공은 했으나 블록 50개를 넘어 대기 중인 상태)
  ETC, // 타입이 하나 더 있을 거 같아서 추가
}
